// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ProductBadge.module.scss  */
.ProductBadge-module-Root_3U_ {
  position: absolute;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: 24px;
  margin: 8px 0 0 8px;
  padding: 0 8px 2px;
  font-size: 16px;
  color: #fff;
  border-radius: 8px; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Product/Badge/ProductBadge.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB,EAAE","sourcesContent":["/*  imported from ProductBadge.module.scss  */\n.ProductBadge-module-Root_3U_ {\n  position: absolute;\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  height: 24px;\n  margin: 8px 0 0 8px;\n  padding: 0 8px 2px;\n  font-size: 16px;\n  color: #fff;\n  border-radius: 8px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
